import type { CardWalletsTranslations } from "../interfaces/cardWallets";

export const cardWalletsTranslations: CardWalletsTranslations = {
  page_title: "Billetera de tarjetas",
  page_subtitle:
    "Acredita o corrige el saldo en USD con el que una organización carga sus tarjetas. Cada movimiento queda registrado con su referencia.",
  refresh_button: "Actualizar",
  refresh_aria: "Actualizar el saldo y los movimientos",
  action_retry: "Reintentar",
  field_organization: "Organización",
  field_organization_required_hint: "Elige la organización cuyo saldo vas a mover.",
  field_organization_hint: "Al elegirla abrimos su billetera de tarjetas.",
  org_picker_placeholder: "Buscar por nombre, correo o id…",
  org_picker_loading: "Cargando organizaciones…",
  org_picker_empty: "No encontramos ninguna organización.",
  org_picker_searching: "Buscando…",
  org_picker_search_error: "No pudimos buscar organizaciones. Intenta de nuevo.",
  org_picker_catalog_error: "No pudimos cargar la lista de organizaciones.",
  org_picker_catalog_truncated: "Hay más organizaciones de las que caben en la lista: busca por nombre o id.",
  landing_title: "Elige una organización para ver su billetera de tarjetas",
  landing_body:
    "Aquí verás el saldo en USD con el que carga sus tarjetas, su historial de movimientos y podrás acreditarlo o corregirlo. Solo se puede ajustar el saldo de las organizaciones cuyas tarjetas funcionan con Coloca Crypto.",

  wallet_balance_label: "Saldo disponible",
  wallet_loading: "Cargando el saldo",
  wallet_pending: "Pendiente {{amount}}",
  wallet_id_label: "Billetera",
  wallet_id_copied: "Copiamos el id de la billetera.",
  wallet_id_copy_action: "Copiar el id de la billetera",
  wallet_status_active: "Activa",
  wallet_status_frozen: "Congelada",
  wallet_status_suspended: "Suspendida",
  wallet_status_closed: "Cerrada",
  wallet_status_notice: "Esta billetera está {{status}}. El movimiento se registrará igual.",
  wallet_just_created: "Esta organización no tenía billetera de tarjetas; acabamos de abrirle una, vacía.",
  wallet_error_title: "No pudimos leer el saldo",
  wallet_error_body:
    "Sin el saldo no podemos mostrarte el antes y el después de un movimiento, así que las acciones quedan desactivadas.",
  action_credit: "Acreditar saldo",
  action_debit: "Debitar saldo",
  actions_footnote: "No se puede deshacer. Para corregir hay que registrar el movimiento contrario.",

  program_crypto: "Coloca Crypto",
  program_cards: "Coloca Cards",
  program_none: "Sin programa",
  ineligible_bloque:
    "Las tarjetas de esta organización funcionan con Coloca Cards. Su saldo lo administra el proveedor y no se ajusta desde aquí.",
  ineligible_no_program:
    "Esta organización todavía no tiene programa de tarjetas, así que no hay saldo que ajustar.",
  ineligible_currency: "Esta billetera no está en USD, así que no se puede ajustar desde aquí.",
  ineligible_wallet_type: "Esta billetera no es la de tarjetas de la organización.",

  dialog_title_credit: "Acreditar saldo",
  dialog_title_debit: "Debitar saldo",
  dialog_description_credit: "Registra un depósito en USD que ya está confirmado en la tesorería de Coloca.",
  dialog_description_debit:
    "Registra una corrección que baja el saldo de la billetera de tarjetas de esta organización.",
  stepper_label: "Pasos del movimiento",
  step_data: "Datos",
  step_review: "Revisión",
  step_result: "Resultado",
  mode_banner_credit: "Vas a acreditar saldo a {{name}} · Billetera de tarjetas · USD",
  mode_banner_debit: "Vas a debitar saldo a {{name}} · Billetera de tarjetas · USD",
  field_reference: "Referencia del depósito",
  field_reference_hint:
    "El identificador con el que vas a conciliar: id del depósito, número de ticket o lote. No se puede repetir en esta billetera, y es el único texto que quedará para quien lea esto después.",
  field_reference_placeholder: "Ej.: DEP-2026-10-14-ACME",
  field_reference_count: "{{used}} / 120",
  field_amount: "Monto",
  field_amount_hint: "En USD, con un máximo de 2 decimales.",
  action_cancel: "Cancelar",
  action_review: "Revisar",
  action_back: "Volver",

  validation_reference: "Escribe la referencia con la que vas a conciliar este movimiento.",
  validation_reference_long: "La referencia no puede pasar de 120 caracteres.",
  validation_amount: "Escribe un monto mayor que cero.",
  validation_amount_precision: "El monto admite como máximo 2 decimales.",
  validation_amount_over_balance: "El saldo disponible es {{balance}}; no alcanza para debitar {{amount}}.",

  review_heading_credit: "Vas a acreditar saldo a {{name}}",
  review_heading_debit: "Vas a debitar saldo a {{name}}",
  review_organization: "Organización",
  review_wallet: "Billetera",
  review_wallet_value: "Tarjetas · USD · {{short}}",
  review_balance_before: "Saldo antes",
  review_movement: "Movimiento",
  review_balance_after: "Saldo después",
  review_reference: "Referencia",
  review_client_sees:
    "En el historial de la organización aparecerá como «Manual balance adjustment», con la fecha y el monto. La referencia que escribiste no la ve el cliente.",
  review_webhook_credit:
    "Si la organización tiene un webhook configurado, le avisamos del abono. No enviamos correo ni notificación en la app.",
  review_webhook_debit:
    "Un débito no avisa a nadie: la organización verá el saldo más bajo sin explicación. Avísale por el canal que corresponda.",
  review_irreversible:
    "Esto no se puede deshacer. Para corregirlo hay que registrar el movimiento contrario, que queda como un segundo registro en el historial.",
  review_checkbox_credit: "Confirmo que el depósito en USD ya está confirmado en la tesorería de Coloca.",
  review_checkbox_debit: "Confirmo que debo retirar este saldo y que ya avisé a la organización.",
  review_balance_moved:
    "El saldo cambió mientras revisabas: ahora es {{balance}}. Revisa el resultado antes de confirmar.",
  action_confirm_credit: "Registrar el abono · {{amount}}",
  action_confirm_debit: "Registrar el débito · {{amount}}",

  done_label: "Movimiento registrado",
  done_pill_credit: "Acreditado",
  done_pill_debit: "Debitado",
  done_amount: "Monto",
  done_balance_before: "Saldo antes",
  done_balance_after: "Saldo después",
  action_another: "Registrar otro movimiento",
  action_close: "Cerrar",

  error_zero: "Escribe un monto mayor que cero.",
  error_currency: "Esta billetera no está en USD, así que no se puede ajustar desde aquí.",
  error_ineligible:
    "Las tarjetas de esta organización funcionan con Coloca Cards y su saldo lo administra el proveedor. No se puede ajustar desde aquí.",
  error_insufficient: "El saldo disponible es {{balance}}; no alcanza para debitar {{amount}}.",
  error_not_found: "No encontramos esta billetera. Puede que la hayan cerrado mientras trabajabas.",
  error_not_found_action: "Volver a buscar la organización",
  error_duplicate_title: "Esta referencia ya se usó",
  error_duplicate_body:
    "Ya existe un movimiento con la referencia «{{reference}}» en esta billetera. El dinero se movió una sola vez, en el primer intento. No lo repitas.",
  error_duplicate_see: "Ver el movimiento",
  error_duplicate_change: "Cambiar la referencia",
  error_duplicate_off_page:
    "El movimiento no está en esta página del historial. Quitamos los filtros para que lo encuentres.",
  error_rate_limited:
    "Solo se puede registrar un movimiento por minuto. Espera un momento y vuelve a intentar.",
  error_rate_limited_retry: "Reintentar en {{seconds}} s",
  error_rate_limited_ready: "Ya puedes reintentar.",
  error_permission:
    "No pudimos autorizar el movimiento. Recarga la página; si sigue igual, pide el permiso al equipo.",
  error_unconfirmed_title: "No sabemos si se registró",
  error_unconfirmed_body:
    "No recibimos respuesta del servidor. Puede que el movimiento sí se haya registrado. No lo repitas con la misma referencia hasta comprobarlo.",
  error_unconfirmed_check: "Comprobar",
  error_unconfirmed_not_placed: "No se registró. Puedes intentarlo otra vez con la misma referencia.",
  error_unconfirmed_still: "Seguimos sin poder comprobarlo. Vuelve a intentar en un momento.",
  error_generic: "No pudimos registrar el movimiento. Vuelve a intentarlo.",

  history_title: "Movimientos de esta billetera",
  col_date: "Fecha",
  col_movement: "Movimiento",
  col_reference: "Referencia",
  col_by: "Registrado por",
  col_amount: "Monto",
  badge_manual_adjustment: "Ajuste manual",
  by_you: "Tú",
  by_unavailable: "No disponible",
  by_unavailable_card: "Autor no disponible en este registro",
  by_unavailable_tooltip:
    "Este tipo de registro no devuelve quién lo hizo. Queda guardado en el backend, pero no llega a esta pantalla.",
  filter_type: "Tipo",
  filter_type_all: "Todos",
  filter_direction: "Dirección",
  filter_direction_all: "Todas",
  filter_direction_in: "Entradas",
  filter_direction_out: "Salidas",
  filter_dates: "Rango de fechas",
  filter_clear: "Limpiar filtros",
  empty_title: "Esta billetera no tiene movimientos todavía",
  empty_description:
    "Los movimientos que registres aquí, y las recargas y transferencias de la organización, aparecerán en esta lista.",
  empty_filtered_title: "No hay movimientos con estos filtros",
  history_error: "No pudimos cargar los movimientos.",

  tx_type_topup: "Recarga",
  tx_type_transfer: "Transferencia",
  tx_type_withdrawal: "Retiro",
  tx_type_fee: "Comisión",
  tx_type_deposit: "Depósito",
  tx_type_reversal: "Reverso",
  tx_type_adjustment: "Ajuste",
  tx_status_pending: "Pendiente",
  tx_status_completed: "Completado",
  tx_status_failed: "Fallido",
  tx_status_reversed: "Reversado",

  tx_desc_manual_adjustment: "Ajuste manual de saldo",
  tx_desc_wallet_recharge: "Recarga de billetera",
  tx_desc_card_crypto_deposit: "Depósito cripto a la tarjeta",
  tx_desc_card_crypto_transfer: "Traslado a la tarjeta por un depósito cripto",
  tx_desc_internal_transfer: "Transferencia entre billeteras",

  quote_button: "Cotizar recarga",
  quote_title: "Cotizador de recargas",
  quote_description:
    "Calcula cuánto debe depositar un cliente y cuánto se le acredita, y consulta la billetera a la que se deposita. No mueve dinero ni registra nada.",
  quote_close: "Cerrar",

  quote_network_label: "Blockchain",
  quote_address_label: "Dirección de la billetera",
  quote_address_copy_aria: "Copiar la dirección de la billetera",
  quote_address_copied: "Copiamos la dirección de la billetera.",
  quote_assets_label: "Activos aceptados",
  quote_asset_contract: "Contrato: {{address}}",
  quote_pool_warning:
    "Solo {{assets}} en {{network}}. Cualquier otro activo, o el mismo en otra red, se pierde y no se puede recuperar.",
  quote_pool_error: "No pudimos leer la billetera de depósito. Sin ella no podemos decirte a dónde enviar.",
  quote_pool_retry: "Reintentar",

  quote_mode_label: "Qué sabes del monto",
  quote_mode_deposit_title: "El cliente paga",
  quote_mode_deposit_description: "Sabes cuánto va a depositar y quieres saber cuánto se le acredita.",
  quote_mode_credited_title: "El cliente quiere recargar",
  quote_mode_credited_description: "Sabes cuánto debe quedar acreditado y quieres saber cuánto depositar.",
  quote_amount_label_deposit: "¿Cuánto paga el cliente?",
  quote_amount_label_credited: "¿Cuánto quiere recargar?",
  quote_amount_hint: "En USD, con un máximo de 2 decimales.",
  quote_commission_label: "Comisión",
  quote_commission_unlock: "Ajustar la comisión",
  quote_commission_hint:
    "Por defecto {{percent}} %. Marca la casilla para cambiarla solo en esta cotización.",
  quote_issue_amount_invalid: "Escribe un monto mayor que cero.",
  quote_issue_commission_invalid: "La comisión debe estar entre 0 % y 100 %.",
  quote_result_pays: "El cliente paga",
  quote_result_deposit: "Debe depositar",
  quote_result_commission: "Comisión ({{percent}} %)",
  quote_result_credited: "Se acredita",
  quote_rounding_note: "Redondeamos hacia arriba al centavo, así que se acreditan {{amount}}.",
  quote_empty: "Escribe un monto para ver la cotización.",
  quote_footnote:
    "Es solo un cálculo de referencia: no reserva ni registra nada. Cuando el depósito llegue, acredita el saldo desde esta pantalla con su referencia.",
};
